export default "__VITE_ASSET__DJ4nn7Np__"